exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-wrapper[data-v-c0564392]{display:flex;align-items:center}.checkbox-wrapper label[data-v-c0564392]{font-size:1rem;margin-bottom:0;color:#222}.checkbox-wrapper input[data-v-c0564392]{margin-right:7px}", ""]);

// exports
